<template>
    <router-link
        :to="route.path"
        :disabled="isInFlight"
        class="button-nav-link"
        :style="{ 'background-color': branding.secondaryColor }"
        :aria-label="route.meta.title"
        type="button"
        role="button"
        @click.middle="newTab( route.path )"
    >
        <MaterialDesignIcon
            v-if="!!route.meta.mdiIcon"
            :className="route.meta.mdiIcon"
            :pxSize="48"
        />
        <p class="link-text">{{ route.meta.title }}</p>
    </router-link>
</template>

<script>
// Vuex
import { mapGetters, mapState } from 'vuex';

// Services
import PageService from '@/services/PageService';

// Components
import MaterialDesignIcon from '@/components/base/MaterialDesignIcon';

export default {
    name: 'ButtonNavLink',
    components: {
        MaterialDesignIcon,
    },
    props: {
        /**
         * A route Object with at least the following:
         * {
         *  path: { String },
         *  meta: {
         *    title: { String },
         *    documentTitle: { String },
         *    requiresAuth: { Boolean },
         *    mdiIcon: { String },
         *  },
         * }
         */
        route: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters( {
            branding: 'Website/branding',
        } ),
        ...mapState( {
            isLoggingIn: ( state ) => state.User.loginInFlight,
            isGettingPermissions: ( state ) => state.User.permissions.inFlight,
        } ),
        /** @returns {{(*): Boolean, (*): Boolean}} */
        isInFlight() {
            return ( this.isLoggingIn || this.isGettingActions );
        },
    },
    methods: {
        newTab( routePath ) {
            PageService.openNewTab( `${ window.location.origin }${ routePath }` );
        },
    },
};
</script>

<style scoped lang="scss">

.mdi {
    color: white;
    &:hover {
        color: white;
    }
}

.link-text {
    color: white;
    font-size: 1.12rem;
    font-weight: bolder;
}

.button-nav-link {
    border-radius: 10px;
    display: flex;
    flex-flow: row nowrap;
    box-shadow: $variables-material-shadow-2;
    &:hover {
        filter: brightness( 1.25 );
        transition: $variables-material-shadow-hover;
        box-shadow: $variables-material-shadow-4;
        .link-text {
            font-size: 125%;
            transition: $variables-material-shadow-hover;
        }
    }
    .mdi,
    .link-text {
        margin-top: auto;
        margin-bottom: auto;
    }
    .mdi {
        margin-left: 1rem;
        margin-right: 1rem;
    }
}

/* Media queries */
@include mixins-above(desktop){
    .button-nav-link {
        flex-flow: column nowrap;
        padding: 2.5rem;
        &:hover {
            .link-text {
                font-size: 175%;
            }
        }
        .mdi,
        .link-text {
            margin: auto;
            font-size: 2.0rem;
        }
    }
}
</style>
